export enum SettingsTypeEnum {
  Tracking = 'tracking',
}
